/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_File_Mac_Cli_TitleInputs */

const en_pc_dl_file_mac_cli_title = /** @type {(inputs: Pc_Dl_File_Mac_Cli_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Command-line tool (Universal)`)
};

const zh_pc_dl_file_mac_cli_title = /** @type {(inputs: Pc_Dl_File_Mac_Cli_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`命令行工具（通用版）`)
};

/**
* | output |
* | --- |
* | "Command-line tool (Universal)" |
*
* @param {Pc_Dl_File_Mac_Cli_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_file_mac_cli_title = /** @type {((inputs?: Pc_Dl_File_Mac_Cli_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_File_Mac_Cli_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_file_mac_cli_title(inputs)
	return zh_pc_dl_file_mac_cli_title(inputs)
});
export { pc_dl_file_mac_cli_title as "pc.dl.file.mac_cli.title" }